import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">District Today · Your Local Connection</p>
        <h1>Discover What’s Happening in Your Community</h1>
        <p className="lede">
          Stay informed and engaged with the latest news, events, and updates from your neighborhood. 
          District Today is your go-to source for everything local.
        </p>
        <div className="cta-row">
          <a href="/events" target="_blank">
            Explore Events
          </a>
          <a href="/news" target="_blank" className="secondary">
            Read Local News
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Stay Updated</h2>
          <p>
            Get real-time updates on local events, news, and community initiatives. 
            Never miss out on what’s important in your area.
          </p>
        </article>
        <article>
          <h2>Engage with Your Community</h2>
          <p>
            Connect with local organizations, participate in events, and contribute to discussions 
            that matter to you and your neighbors.
          </p>
        </article>
        <article>
          <h2>Share Your Voice</h2>
          <p>
            Have something to say? Submit your stories, events, or opinions and help shape the narrative 
            of your community.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;